import React, { ReactNode, useEffect, useState } from 'react'
import DesnsitzeConfirm from './desnsitzeConfirm'
import DesensitzePhone from './desensitzePhone'
import useGee from '@/commonHooks/useGee'

interface Props {
    visible: boolean
    onClose?: () => void
    className?: string
    onSuccess?: (v: string) => void,
    fingerprint: string,
    encryptedString?: string

}

const DesensitzeData = (props: Props) => {
    const { visible, onClose, onSuccess, fingerprint, encryptedString = '' } = props

    const [confirmVisible, setConfirmVisible] = useState(false)
    const [phoneVisible, setPhoneVisible] = useState(false)

    const handleGeeSuccess = (res: any) => {
        setPhoneVisible(true)
    }

    const handleGeeColse = () => {
        onClose?.()
    }
    const { show } = useGee({
        onSuccess: handleGeeSuccess,
        onClose: handleGeeColse
    })

    useEffect(() => {
        if (visible) {
            setConfirmVisible(true)
        }
    }, [visible])

    return (
        <>
            <DesnsitzeConfirm visible={confirmVisible} onClose={() => {
                setConfirmVisible(false)
                onClose?.()
            }}
                onSubmit={() => {
                    show()
                }}
            />

            <DesensitzePhone
                fingerprint={fingerprint}
                encryptedString={encryptedString}
                visible={phoneVisible} onClose={() => {
                    setPhoneVisible(false)
                }} onSuccess={(v) => {
                    onSuccess?.(v)
                }} />
        </>
    )
}

export default DesensitzeData
